// Max hours config for forecast
export const HOURS_CONFIG = {
  weeks: {
    light: 0.625,    // ~62.5% of max (was 25/40)
    moderate: 0.875, // ~87.5% of max (was 35/40)
    heavy: 1.0,      // 100% of max
  },
  days: {
    light: 0.625,    // ~62.5% of max (was 5/8)
    moderate: 0.875, // ~87.5% of max (was 7/8)
    heavy: 1.0,      // 100% of max
  },
};

export const NUMBER_OF_WEEKDAYS = 5;
// Regular Expressions
export const RE_MATTER_CODE = /^[0-9-]{1,12}$/;
// eslint-disable-next-line sonarjs/slow-regex
export const THOUSAND_SEPARATOR = /(\d)(?=(\d{3})+\b)/g;

// Lookup Table IDs
export const REFERENCE_TABLE_IDS = {
  sectors: 10,
  skills: 11,
  experience: 9,
  futureSectors: 8,
};

// User Regions
export const USER_REGION = {
  ocea: "OCEA",
};

// Priority sectors which are available on Sector Hub
export const PRIORITY_SECTORS = [
  "BNK",
  "CON",
  "ERG",
  "INF",
  "MIN",
  "PHA",
  "RES",
  "TMT",
];

// Permission roles
export const USER_ROLE = {
  wam: "People.WorkAllocationManager",
  sectorAdmin: "Sector.Admin",
  partner: "People.Partner",
  terminologyAdmin: "Terminology.Admin",
  insiderReport: "Matter.Insider.User",
  sectorHubAccess: "SectorHub.Access",
  hssAccess: "HSS.Access",
  CompaniesHouseAccess: "CompaniesHouse.Access",
};

// Statistical Trend values
export const TREND_LOWER = "lower";
export const TREND_HIGHER = "higher";
export const TREND_EQUAL = "equal";

// Work Allocation Skill Groups
export const SKILL_GROUPS = [
  "corporate",
  "finance",
  "disputes",
  "information technology",
  "real estate",
];

// Trend summary number formats
export const TREND_SUMMARY_NUM_FORMAT = ["number", "currency", "percentage"];

// Genesis Types
export const GENESIS_TYPE_ARBITRATION = "arbitration";
export const GENESIS_TYPE_LITIGATION = "litigation";

// @deprecated Settings moved to Settings Composable. LocalStorage is deprecated.
export const LOCALSTORAGEKEY_WEBPUSH = "web-push-enabled";
export const LOCALSTORAGEKEY_OFFER_NOTIFICATIONS =
  "notifications-offered-and-delayed";
export const LOCALSTORAGEKEY_THEME = "settingsHurricaneTheme";
export const LOCALSTORAGEKEY_SETTINGS_PAGE = "settingsSelectedTab";
export const LOCALSTORAGEKEY_HSFAI_ENABLED = "settingsEnableHSFAISidebar";
export const LOCALSTORAGEKEY_CLOUDDATA_ENABLED = "settingsEnableCloudData";
export const LOCALSTORAGEKEY_PREVIEWMODE_ENABLED = "settingsEnablePreviewMode";
export const LOCALSTORAGEKEY_RECENTLY_VIEWED_ENTITIES = "recentlyViewed";

// Settings Keys for IndexedDB settings
export const SETTING_HSFAI_ENABLED = "HSFAI:AcceptedTerms";
export const SETTING_HSFAI_SELECTED_MODEL = "HSFAI:SelectedModel";
export const SETTING_HSFAI_SELECTED_TEMPERATURE = "HSFAI:SelectedTemperature";
export const SETTING_HSFAI_SHOW_TOKENS = "HSFAI:ShowTokens";
export const SETTING_HSFAI_PROMPT_PERSONALISATION = "HSFAI:PromptPersonalisation";
export const SETTING_HSFAI_PROMPT_ADDITIONAL = "HSFAI:PromptAdditional";
export const SETTING_HSFAI_SKILLS_BANNER_DISMISSED = "HSFAI:SkillsBannerDismissed";
export const SETTING_CLOUDDATA_ENABLED = "GLOBAL:enableCloudData";
export const SETTING_THEME = "GLOBAL:theme";
export const SETTING_PREVIEW_MODE = "GLOBAL:enablePreviewMode";
export const SETTING_PAGE = "SETTING:selectedTab";

// @deprecated Other LocalStorage moved to Settings Composable
export const LOCALSTORAGEKEY_MATTER_FAMILY_VIEW = "matter-family-mode";

// Other keys for IndexedDB
export const UI_MATTER_FAMILY_VIEW = "UI:MatterViewFamilyTab";

// Key value pairs to represent values of each placeholder status
export const PLACEHOLDER_MATTER_STATUS = [
  { key: "Awareness", value: "Awareness - Establishing Client Awareness" },
  { key: "Interest", value: "Interest - Proactive engagement with HSF offerings to meet client needs" },
  { key: "Connection", value: "Connection - Client engages in consultative Sales exercise" },
  { key: "Action", value: "Action - Client forms intent to purchase" },
  { key: "Conversion", value: "Conversion - HSF undertakes delivery for client" },
  { key: "Closed", value: "Closed - Opportunity not progressed" },
];

// Secondment category IDs
export const SECONDMENT_CATEGORIES = {
  CLIENT: ['CS', 'ICS'], // Client secondment categories
  HSF: ['DA', 'InternalS'], // HSF/Internal secondment categories
};
